import { defineStore } from 'pinia'

import type { AuthStore } from '@stores/auth/interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useAuthStore = defineStore('auth', {
  state: (): AuthStore => ({
    loading: false,
    accessToken: '',
    refreshToken: '',
    tokenType: 'Bearer',
    expiresAt: 0,
    refreshing: null,
    email: null,
    errorEmail: null,
    password: null,
    errorPassword: null,
    remember: false,
  }),
  actions,
  getters,
})
